const colours = {
  grey: '#6b6c6f',
  blue: '#0F25FF',
  black: '#000',
  white: '#fff',
}

export default colours
